import { SectionNav } from "./SectionNav";
import { PIPELINE_SLOTS } from "./sections";

// RUN › Pipeline — the working pipeline, organised by phase (#2218). Reuses the
// SectionNav shell for its third-level sub-nav; context forwards through the
// nested Outlet so the stage panels receive the campaign unchanged.
export function PipelineSection() {
  return <SectionNav slots={PIPELINE_SLOTS} ariaLabel="Pipeline sections" />;
}
